module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Radio-a8d747718adb99f84cd3ffda24628b01.svg";